import { IOtherPLGR } from "../../interfaces/IOtherPLGR";
import { setOTHERPLGR } from "../constants/otherPLGRObject.types";

export const setOtherPLGR = (otherPLGRObject: IOtherPLGR) => {
  return {
    type: setOTHERPLGR,
    payload: otherPLGRObject,
  };
};
